export const PREVENTIVE_OUT_WIDGET = {
    SET_LOADING : 'PREVENTIVE_OUT_SET_LOADING',
    SET_ITEMS : 'PREVENTIVE_OUT_SET_ITEMS',
    RESET : 'PREVENTIVE_OUT_RESET',
    SET_ERROR : 'PREVENTIVE_OUT_SET_ERROR'
};

export const PREVENTIVE_WIDGET = {
    SET_CIRCLE_LOADING : 'PREVENTIVE_SET_CIRCLE_LOADING',
    SET_CHART_LOADING : 'PREVENTIVE_SET_CHART_LOADING',
    SET_CIRCLE_ITEMS : 'PREVENTIVE_SET_CIRCLE_ITEMS',
    SET_CHART_ITEMS : 'PREVENTIVE_SET_CHART_ITEMS',
    RESET : 'PREVENTIVE_SET_CHRESET',
    SET_ERROR : 'PREVENTIVE_SET_ERROR'
};

export const BILLING_WIDGET = {
    SET_LOADING : 'BILLING_SET_LOADING',
    SET_ITEMS : 'BILLING_SET_ITEMS',
    RESET : 'BILLING_RESET',
    SET_ERROR : 'BILLING_SET_ERROR'
};

export const ESTIMATE_WIDGET = {
    SET_LOADING : 'ESTIMATE_SET_LOADING',
    SET_ITEMS : 'ESTIMATE_SET_ITEMS',
    RESET : 'ESTIMATE_RESET',
    SET_ERROR : 'ESTIMATE_SET_ERROR'
};

export const INTERVENTION_REQUEST_WIDGET = {
    SET_LOADING : 'INTERVENTION_REQUEST_WIDGET_SET_LOADING',
    SET_ITEMS : 'INTERVENTION_REQUEST_WIDGET_SET_ITEMS',
    RESET : 'INTERVENTION_REQUEST_WIDGET_RESET',
    SET_ERROR : 'INTERVENTION_REQUEST_WIDGET_SET_ERROR'
};

export const HOME = {
    SET_HOMEPAGE_COMMUNICATION : 'HOME_SET_HOMEPAGE_COMMUNICATION',
    SET_ACTUALITES : 'SET_ACTUALITES',
    SET_NB_NOUVELLES_ACTUS : 'SET_NB_NOUVELLES_ACTUS',
    SET_ACTUALITE_OPEN : 'SET_ACTUALITE_OPEN',
    SET_ACTUALITE_LOADING: 'SET_ACTUALITE_LOADING',
    SET_REGISTER_MAIL_LOADING: 'SET_REGISTER_MAIL_LOADING',
    SET_NB_NOUVELLES_RECLAMATIONS: 'SET_NB_NOUVELLES_RECLAMATIONS',
    SET_LANGUES_DISPONIBLES: 'SET_LANGUES_DISPONIBLES',
    SET_LANGUE_SELECTIONNEE: 'SET_LANGUE_SELECTIONNEE',
    SET_TRADUCTIONS: 'SET_TRADUCTIONS',
    SET_MODAL_CHOIX_PORTAIL_OUVERTE: 'SET_MODAL_CHOIX_PORTAIL_OUVERTE',
    SET_WIDGETS: 'SET_WIDGETS',
    SET_DASHBOARDS: 'SET_DASHBOARDS',
    SET_SELECTED_DASHBOARD: 'SET_SELECTED_DASHBOARD',
    SET_CREATED_DASHBOARD: 'SET_CREATED_DASHBOARD',
    SET_ENREGISTREMENT_EN_COURS: 'SET_ENREGISTREMENT_EN_COURS',
    SET_ENREGISTREMENT_MODALE_EN_COURS: 'SET_ENREGISTREMENT_MODALE_EN_COURS',
    SET_LIBELLE_DASHBOARD: 'SET_LIBELLE_DASHBOARD',
    SET_WIDGET_POSITION: 'SET_WIDGET_POSITION',
    OPEN_MODAL_WIDGET: 'OPEN_MODAL_WIDGET',
    SET_DASHBOARD_LOADING: 'SET_DASHBOARD_LOADING',
    SET_SATISFACTION_CONDITIONS: 'SET_SATISFACTION_CONDITIONS',
    RESET: 'HOME_RESET'
};
